<template>
  <v-parallax
    v-if="
      parseBoolean(section.design['parallax-background-image']) && allowParallax
    "
    v-bind="$attrs"
    :src="image.src"
    :lazy-src="image['lazy-src']"
  ></v-parallax>

  <v-img
    v-else
    v-bind="$attrs"
    :src="image.src"
    :lazy-src="image['lazy-src']"
  ></v-img>
</template>

<script>
export default {
  name: 'ParallaxBackgroundImage',
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    image() {
      let src = this.section.design['background-image']
      let size = 'xl'

      switch (this.screenSize) {
        case 'md':
          size = 'lg'
          break
        case 'sm':
          if (this.section.design['background-image-tablet']) {
            src = this.section.design['background-image-tablet']
          }

          size = 'md'
          break
        case 'xs':
          if (this.section.design['background-image-mobile']) {
            console.log(this.screenSize)
            src = this.section.design['background-image-mobile']
          } else if (this.section.design['background-image-tablet']) {
            src = this.section.design['background-image-tablet']
          }

          size = 'sm'
          break
      }

      return {
        src: this.loadMedia(src, size),
        'lazy-src': this.loadMedia(src, 'thumbnail')
      }
    }
  }
}
</script>
